export const MapPeriod = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十']
export const ClientHeight =
  window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
